import { CheckAutoOnboardingDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Content from './_Content'

const ProductUpdateAutoOnboarding = () => {
  const { data: policies } = useQuery(CheckAutoOnboardingDocument)
  const isAuthorized = policies?.trial._policies.companyOnboardingShowCompanyOnboarding.can
  return (
    <ResponsivePage.Body showHeader={false} authorized={isAuthorized}>
      <Content />
    </ResponsivePage.Body>
  )
}

export default ProductUpdateAutoOnboarding
